/**
 * ToastNotification
 * 
 * Displays temporary notification messages (item collection, saves, etc.)
 * Supports optional speaker name and icon for character-style notifications.
 */

import { useEffect } from 'react';
import styles from './toast-notification.module.css';

export interface ToastData {
  text: string;
  speaker?: string;
  icon?: string;
}

interface ToastNotificationProps {
  message: string | ToastData;
  onClose: () => void;
  duration?: number;
}

export function ToastNotification({ message, onClose, duration = 5000 }: ToastNotificationProps): JSX.Element {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const isRich = typeof message === 'object';
  const text = isRich ? message.text : message;
  const speaker = isRich ? message.speaker : undefined;
  const icon = isRich ? message.icon : undefined;

  return (
    <div className={styles.toast}>
      <div className={`${styles.toastContent} cn-zoom-ui ${speaker ? styles.characterToast : ''}`}>
        {icon && <img src={icon} alt={speaker} className={styles.toastIcon} />}
        <div className={styles.toastBody}>
          {speaker && <span className={styles.toastSpeaker}>{speaker}</span>}
          <span className={styles.toastText}>{text}</span>
        </div>
      </div>
    </div>
  );
}

